import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    color: theme?.palette?.secondary?.main,
    "& label": {
      margin: 0,
      lineHeight: "17px",
    },
  },
  label: {
    cursor: "pointer",
    userSelect: "none",
  },
  checkedDisabled: {
    // Counter the legacy checkbox's 50% disabled fade (opacity lives on its
    // inner wrapper, hence the child selector). Unchecked-disabled boxes
    // keep their faded look; only checked ones are restored so a locked
    // "on" value can't be mistaken for "off". Cursor still says read-only.
    "& > div": {
      opacity: "1 !important",
    },
    cursor: "not-allowed",
  },
}));
